import { render, staticRenderFns } from "./ProjectsTableDetailRow.vue?vue&type=template&id=7675e150"
import script from "./ProjectsTableDetailRow.vue?vue&type=script&lang=js"
export * from "./ProjectsTableDetailRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports